














import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import _ from "lodash";
import {getWeekNumber} from "element-ui/src/utils/date-util";
import EventBus from "front-component/EventBus";

@Component({})
export default class DatePickerSearch extends Vue {
    @Prop({ default: "" }) public value!: string;
    @Prop() public filterName!: string;
    @Prop() public placeholder!: string;
    @Prop() public filters!: any;
    @Prop() public marketYear!: string;
    @Prop({ default: false }) public weekNumber!: boolean;


    private filter: string = "";

    @Watch("value", { immediate: true }) private updateValue() {
        this.filter = this.value;
    }

    @Watch("filter") public onFilterChange(value: string): void {
        EventBus.$emit("update-filter", _.set({}, this.filterName, value));
    }

    private get pickerOptions() {
        if (this.weekNumber) {
            return {
                firstDayOfWeek: 1,
                cellClassName(date: Date) {
                    if (date.getDay() === 1) {
                        return "week-number-" + getWeekNumber(date);
                    }
                },
            };
        }
        return {};
    }
}
